import {Component, Input} from '@angular/core'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {faHeart} from '@fortawesome/pro-solid-svg-icons/faHeart'
import {LinkService} from '../../../i18n/link.service'
import {TranslocoDirective} from '@ngneat/transloco'
import {PipesModule} from '../../../../shared/pipes/pipes.module'
import {DirectivesModule} from '../../../../shared/directives/directives.module'
import {RouterLink} from '@angular/router'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'

@Component({
  selector: 'bgo-minimal-footer',
  templateUrl: './minimal-footer.component.html',
  styleUrls: ['./minimal-footer.component.css'],
  standalone: true,
  imports: [PipesModule, DirectivesModule, RouterLink, FontAwesomeModule, TranslocoDirective],
})
export class MinimalFooterComponent {
  readonly faHeart = faHeart

  @Input()
  showProSignUp = true

  @Input()
  showLegalLinks = true

  @Input()
  noFooterMargin = false

  readonly APPLICATION_ROUTES = PUBLIC_ROUTES

  constructor(readonly linkService: LinkService) {}
}
